import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TableColumnsService } from '@app/_shared/providers/table-columns/table-columns.service';
import { cloneDeep, remove } from 'lodash-es';
import { BOOKS_MAPPING, COLUMN_NAMES_MAPPINGS } from '../../table-columns-mappings';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-rearrange-columns',
  templateUrl: './rearrange-columns.component.html',
  styleUrls: ['./rearrange-columns.component.scss']
})
export class RearrangeColumnsComponent implements OnInit {

  totalColumns = [];
  mapping = COLUMN_NAMES_MAPPINGS[this.tableName];

  constructor(
    @Inject(MAT_DIALOG_DATA) private tableName: string,
    private dialogRef: MatDialogRef<RearrangeColumnsComponent>,
    private tableColumnsService: TableColumnsService
  ) {
    tableColumnsService.getColumns(tableName).subscribe((response: string[]) => {
      this.totalColumns = this.removeSelectField(response);
    });
  }

  ngOnInit(): void {
  }

  // To remove select field (row checkbox) from showing in show hide
  removeSelectField(fields: string[]): string[] {
    const tempFields = cloneDeep(fields);
    return remove(tempFields, el => { return el !== 'strategy_type'  && el !== 'position_type'});
  }

  closeDialog(response?) {
    this.dialogRef.close(response);
  }

  reorderColumns(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.totalColumns, event.previousIndex, event.currentIndex);
  }
  /**
   * FOR RA-1021 
   * Data is sent by deepcloning it without the select checkbox so that on
   * clicking save, select is not shown in the dialog box before closing. 
   */
  saveColumnOrder() {
    const selected = cloneDeep(this.totalColumns);
    this.tableColumnsService.setColumns({ key: this.tableName, data: selected }).subscribe((response) => {
      this.closeDialog(response);
    });
  }

}
